<app-toast></app-toast>
@if (pageLoaderService.isLoading()) {
<div class="full-page-loader">
  <app-card-loader></app-card-loader>
</div>
}
<div class="app-container">
  <app-header (themeChange)="onThemeChange($event)"></app-header>
  <div class="app-layout">
    @if (showSideMenu()) {
    <app-side-menu></app-side-menu>
    }
    <main class="app-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
